module.exports = __webpack_public_path__ + "img/macOS.ce31eaa.png";